import mobileHomeEn from "./MobileHomeScreen-en.png";
import mobileHomeFr from "./MobileHomeScreen-fr-portrait.png";
import aiScanEn from "./AIScan-en-portrait.png";
import aiScanFr from "./AIScan-fr-portrait.png";
import dashboardHomeEn from "./DashboardHomeScreen-en.png";
import dashboardHomeFr from "./DashboardHomeScreen-fr.png";
import dashboardExpensesEn from "./DashboardExpenseManagement-en.png";
import dashboardExpensesFr from "./DashboardExpenseManagement-fr.png";

const screenshots = {
  en: {
    mobileHome: mobileHomeEn,
    aiScan: aiScanEn,
    dashboardHome: dashboardHomeEn,
    dashboardExpenses: dashboardExpensesEn,
  },
  fr: {
    mobileHome: mobileHomeFr,
    aiScan: aiScanFr,
    dashboardHome: dashboardHomeFr,
    dashboardExpenses: dashboardExpensesFr,
  },
};

export default screenshots;
